import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-9c5973c0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "video-box guide-target",
  "data-target": "video"
};
import { ref, onMounted, watch } from 'vue';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
// import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
// import {}
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var screenMediaService = useService(ScreenMediaService);
    var videoRef = ref(null);
    var moveElRef = ref(null);
    var onMoveStart = function (ev) {
      var moveEl = moveElRef.value;
      if (moveEl) {
        var clientX = ev.clientX,
          clientY = ev.clientY;
        var _a = moveEl.getBoundingClientRect(),
          left = _a.left,
          top = _a.top,
          width_1 = _a.width,
          height_1 = _a.height;
        var offsetX_1 = clientX - left;
        var offsetY_1 = clientY - top;
        var onMove_1 = function (moveEv) {
          var moveX = moveEv.clientX,
            moveY = moveEv.clientY;
          // 获取页面宽高
          var pageWidth = document.documentElement.clientWidth;
          var pageHeight = document.documentElement.clientHeight;
          // 计算新的位置
          var newLeft = moveX - offsetX_1;
          var newTop = moveY - offsetY_1;
          // 限制元素不能超出页面边界
          var limitLenW = width_1 - 10;
          var limitLenH = height_1 - 10;
          newLeft = Math.max(limitLenW - width_1, Math.min(pageWidth - limitLenW, newLeft));
          newTop = Math.max(limitLenH - height_1, Math.min(pageHeight - limitLenH, newTop));
          moveEl.style.left = "".concat(newLeft, "px");
          moveEl.style.top = "".concat(newTop, "px");
        };
        var onMoveEnd_1 = function () {
          document.removeEventListener('mousemove', onMove_1);
          document.removeEventListener('mouseup', onMoveEnd_1);
        };
        document.addEventListener('mousemove', onMove_1);
        document.addEventListener('mouseup', onMoveEnd_1);
      }
    };
    onMounted(function () {
      watch(function () {
        return screenMediaService.stream;
      }, function (newStream) {
        if (newStream && videoRef.value) {
          videoRef.value.srcObject = newStream;
        }
      }, {
        immediate: true
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "record-video-area",
        ref: function (_value, _refs) {
          _refs['moveElRef'] = _value;
          moveElRef.value = _value;
        },
        onMousedown: onMoveStart
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("video", {
        ref: function (_value, _refs) {
          _refs['videoRef'] = _value;
          videoRef.value = _value;
        },
        autoplay: "",
        playsinline: "",
        muted: "",
        class: "video"
      }, null, 512)])], 544);
    };
  }
});